import axios from "axios";
import { API_BASE_URL } from "../constants/api";

/** Re-export for callers that need the resolved API root. */
export { API_BASE_URL };

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 20000,
});

/** Matches CMS page requests: ?limit=5&page=1&slug=… */
export const PUBLIC_CONTENT_PAGE_LIMIT = 5;
export const PUBLIC_CONTENT_PAGE = 1;

/**
 * Public published content list.
 * GET /user/content/public
 * Response: { data: { items, page, limit }, status, message }
 * Each item: { id, title, slug, body, type, createdAt?, updatedAt? }
 */
export async function fetchPublicContents({ limit = 50, page = 1, type, slug } = {}) {
  const params = { limit, page };
  if (type) params.type = type;
  if (slug && String(slug).trim()) params.slug = String(slug).trim();
  const { data } = await api.get("/user/content/public", { params });
  return data;
}

/**
 * Single-slug fetch — same as:
 * GET /user/content/public?limit=5&page=1&slug=help-desk
 * GET /user/content/public?limit=5&page=1&slug=privacy-policy
 */
export async function fetchPublicContentsBySlug(
  slug,
  {
    limit = PUBLIC_CONTENT_PAGE_LIMIT,
    page = PUBLIC_CONTENT_PAGE,
  } = {}
) {
  if (!slug || typeof slug !== "string") {
    throw new Error("slug is required");
  }
  const { data } = await api.get("/user/content/public", {
    params: {
      limit,
      page,
      slug: slug.trim(),
    },
  });
  return data;
}

export default api;
